/* src/app/private/components/registration/upload-documents/upload-documents.component.scss */
.p-fileupload-buttonbar {
  display: none !important;
}
.p-fileupload {
  width: 100%;
}
/*# sourceMappingURL=upload-documents.component.css.map */
